import React from "react";
import styles from './Tooltip.module.css';

export default class TooltipIcon extends React.Component {

    render() {

        return (
            <div className="tooltip bs-tooltip-right position-absolute" id={this.props.id}>
                <div className="arrow"></div>
                <div className={styles.toolInn.concat(" p-1")} style={{width:this.props.width}}> {this.props.text} </div>
            </div>
        );

    }

}